

import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  IconButton,
  InputAdornment,
  Paper,
  Divider,
} from "@mui/material";
import { Visibility, VisibilityOff, LockOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


function Login() {
  const navigate = useNavigate();
  const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // --- Logic Kept Exactly Same ---
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    username: "",
    password: "",
    api: "",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validate = () => {
    let newErrors = { username: "", password: "", api: "" };
    // if (!formData.username.trim()) newErrors.username = "Username is required";
    if (!formData.username.trim()) {
      newErrors.username = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.username)
    ) {
      newErrors.username = "Enter a valid email address";
    }
    if (!formData.password.trim()) newErrors.password = "Password is required";
    setErrors(newErrors);
    return !newErrors.username && !newErrors.password;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    let newErrors = { ...errors, [name]: "", api: "" };

    if (name === "username") {
      if (!value.trim()) {
        newErrors.username = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
      ) {
        newErrors.username = "Enter a valid email address";
      }
    }

    setErrors(newErrors);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validate()) return;
  //   setLoading(true);
  //   try {
  //     const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(formData),
  //     });

  //     const data = await response.json();

  //     if (!response.ok) {
  //       setErrors((prev) => ({
  //         ...prev,
  //         api: data?.message || data?.error || "Invalid credentials",
  //       }));
  //       return;
  //     }

  //     const token = data.token || data.access || data.jwt;
  //     if (!token) {
  //       setErrors((prev) => ({ ...prev, api: "Token not received" }));
  //       return;
  //     }

  //     localStorage.setItem("accessToken", token);
  //     const base64Url = token.split(".")[1];
  //     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  //     const decoded = JSON.parse(window.atob(base64));

  //     localStorage.setItem("customerId", decoded.customerId);
  //     localStorage.setItem("tenantId", decoded.tenantId);
  //     localStorage.setItem("userId", decoded.userId);
  //     localStorage.setItem("userName", decoded.sub);

  //     if (decoded.scopes && decoded.scopes.length > 0) {
  //       localStorage.setItem("role", decoded.scopes[0]);
  //     }

  //     navigate("/dashboard");
  //   } catch (error) {
  //     setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchOrganization = async (token) => {
    try {
      const response = await fetch(`${DJANGO_API}/api/get_organization/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      console.log("Organization API FULL:", data);

      // ✅ Correct extraction
      const customerId = data?.customers?.[0]?.id?.id;

      if (customerId) {
        localStorage.setItem("customer_id", customerId);
        console.log("Stored customer_id:", customerId);
      } else {
        // localStorage.removeItem("customer_id");
        console.warn("No customer found in response");
      }

    } catch (error) {
      console.error("Error fetching organization:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    try {
      const response = await fetch(`${DJANGO_API}/api/web_login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrors((prev) => ({
          ...prev,
          api: data?.message || data?.error || "Invalid credentials",
        }));
        return;
      }

      const token = data.token;
      if (!token) {
        setErrors((prev) => ({ ...prev, api: "Token not received" }));
        return;
      }

      // Store token
      localStorage.setItem("accessToken", token);

      // Decode JWT to extract IDs
      const decoded = jwtDecode(token);
      console.log("Decoded JWT:", decoded);
      const refreshToken = data.refreshToken;
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("customer_id", decoded.customerId);
      localStorage.setItem("tenantId", decoded.tenantId);
      localStorage.setItem("userId", decoded.userId);
      localStorage.setItem("userName", decoded.sub);
      await fetchOrganization(token);


      // Store role for sidebar menu
      if (data.U_Type) {
        localStorage.setItem("role", data.U_Type);
      }

      navigate("/dashboard");
    } catch (error) {
      setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
    } finally {
      setLoading(false);
    }
  };
  // --- Modern UI Rendering ---
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)", // Modern gradient
        padding: 2,
      }}
    >
      <Paper
        elevation={20}
        sx={{
          width: "100%",
          maxWidth: 420,
          p: 3,
          borderRadius: 4,
          textAlign: "center",
          bgcolor: "rgba(255, 255, 255, 0.9)", // Glassmorphism effect
          backdropFilter: "blur(10px)",
        }}
      >
        {/* Modern Branding Area */}
        {/* <Box
          sx={{
            width: 50,
            height: 50,
            bgcolor: "primary.main",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
            boxShadow: "0px 4px 20px rgba(25, 118, 210, 0.4)",
          }}
        >
          <LockOutlined sx={{ color: "white" }} />
        </Box> */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img
            src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
            alt="Ignis Vigil Logo"
            style={{
              width: "200px",
              height: "100px",
              objectFit: "cover",
              objectPosition: "center"
            }}
          />
        </Box>

        <Typography
          variant="h6"
          fontWeight="700"
          sx={{ mt: 2 }}
        >
          IoT & Smart Fire Fighting Systems Monitoring
        </Typography>
        <br></br><br></br>

        {errors.api && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {errors.api}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            name="username"
            variant="outlined"
            value={formData.username}
            onChange={handleChange}
            error={!!errors.username}
            helperText={errors.username}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />

          <TextField
            fullWidth
            label="Password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            error={!!errors.password}
            helperText={errors.password}
            sx={{ mb: 1, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Typography
            variant="caption"
            sx={{
              display: "block",
              textAlign: "right",
              mb: 3,
              cursor: "pointer",
              color: "primary.main",
              fontWeight: 600,
            }}
          >
            Forgot password?
          </Typography>

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 600,
              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            {loading ? "Verifying..." : "Sign In"}
          </Button>
        </form>


      </Paper>
    </Box>
  );
}

export default Login;